import React from 'react';

function FallbackSpinner() {
  return (
    <div className="fallback-spinner">
      <span className="fallback-spinner__ring" aria-hidden="true" />
    </div>
  );
}

export default FallbackSpinner;
